<script lang="ts">
  import LL from '$i18n/i18n-svelte';
  import { idToSubcategory } from './stores';
  import { getSubcategoryName } from './translation';

  export let weaponSubcategoryId: string;

  $: subcategory = $idToSubcategory.get(weaponSubcategoryId);
  $: src = `/images/weapons/Ico_Ability_${subcategory?.id}.webp`;
</script>

<img
  class="weapon-image"
  {src}
  alt={getSubcategoryName($LL, weaponSubcategoryId)}
  {...$$restProps}
/>
